module.exports = __webpack_public_path__ + "static/media/seal work5.99ac2906.png";